import { connect } from '@atlassian/jira-issue-view-react-redux';
import {
	cancelFailedWebLinkDeletion,
	createWebLinkRetry,
	deleteOptimisticWebLink,
	deleteWebLinkRequest,
} from '@atlassian/jira-issue-view-store/src/actions/web-links-actions';
import SmartLinkComponent from './main';
import type { Props, DispatchProps } from './types';

export default connect<{}, DispatchProps, Props>(null, (dispatch, { linkId }) => ({
	onCreateWebLinkRetry: () => {
		dispatch(createWebLinkRetry(linkId));
	},
	onCreateWebLinkCancel: () => {
		dispatch(deleteOptimisticWebLink(linkId));
	},
	onDeleteWebLinkRetry: () => {
		dispatch(deleteWebLinkRequest(linkId));
	},
	onDeleteWebLinkCancel: () => {
		dispatch(cancelFailedWebLinkDeletion(linkId));
	},
}))(SmartLinkComponent);
